module.exports = __webpack_public_path__ + "img/arrow-left-bold.4d18d0f5.svg";